<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">{{headerTitle}}</h1>
<mat-dialog-content class="mb-4">
  <div class="col-md-12 mb-2">
    <label for="reorder" class="payingClinic col-md-6 required">Reorder Level</label>
    <input type="number" class="form-control d-inline-block input-font name inputBox col-md-6" id="reorder"
      [(ngModel)]="threshold">
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row col-md-12 justify-content-center ml-2">
    <button mat-button class="mat-raised-button mr-4 btn blankTurquoise btnWidth"
      (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth btn-sm updateButton"
      (click)="updateThresholdItem()">Update</button>
  </div>
</mat-dialog-actions>
